class BMR {
    gu = null;
    energy = null;
    protein = {
        min: 0,
        max: 0,
    };

    constructor($el, bmiCalculator) {
        this.$el = $el;
        this.bmiCalculator = bmiCalculator;
        this.$bmi = this.bmiCalculator.$output;
        this.gender = this.bmiCalculator.gender;
        this.age = this.bmiCalculator.age;
        this.$activityLevel = $('[name="activity_level"]');
        this.$sicknessLevel = $('[name="sickness_level"]');
        this.$renalInsufficency = $('[name="renal_insufficency"]');

        this.$gu = $('[data-bmr="bmr"]');
        this.$energy = $('[data-bmr="energy"]');
        this.$proteinMin = $('[data-bmr="protein-min"]');
        this.$proteinMax = $('[data-bmr="protein-max"]');
        this.$separator = $('[data-bmr="separator"]');

        this.$output

        this.init();
    }

    init = () => {
        this.$bmi.on('input', this.bmiChangedHandler);
        this.$activityLevel.on('input', this.energyChangeHandler);
        this.$sicknessLevel.on('input', this.energyChangeHandler);
        this.bmiCalculator.$weight.on('change', this.proteinChangeHandler);
        this.$renalInsufficency.on('change', this.proteinChangeHandler);
        this.bmiChangedHandler();
    }

    energyChangeHandler = () => {
        this.calculateEnergy();
        this.displayEnergy();
    }

    proteinChangeHandler = () => {
        this.calculateProtein();
        this.displayProtein();
    }

    bmiChangedHandler = () => {
        this.calculateGU();
        this.calculateEnergy();
        this.calculateProtein();
        this.displayValues();

        this.$el.trigger('bmrChanged');
    }

    calculateGU = () => {
        const bmi = this.bmiCalculator.bmi;
        const weight = bmi >= 16 && bmi <= 28 ? this.bmiCalculator.weight : this.bmiCalculator.adjustedWeight;
        const height = this.bmiCalculator.height;

        // männlich
        if (this.gender == '1') {
            this.gu = Number.parseFloat(66.4730 + (13.7516 * weight) + (5.0030 * height) - (6.7550 * this.age)).toFixed(0);
        }
        // weiblich
        else if (this.gender == '2') {
            this.gu = Number.parseFloat(655.0955 + (9.5634 * weight) + (1.8496 * height) - (4.6756 * this.age)).toFixed(0);
        }

    }

    calculateEnergy = () => {
        const activityLevel = parseFloat(this.$activityLevel.val());
        const sicknessLevel = parseFloat(this.$sicknessLevel.val());

        this.energy = Number.parseFloat(this.gu * (activityLevel + sicknessLevel - 1)).toFixed(0);

        this.$el.trigger('energyChanged');
    }

    calculateProtein = () => {
        const bmi = this.bmiCalculator.bmi;
        const weight = bmi >= 16 && bmi <= 28 ? this.bmiCalculator.weight : this.bmiCalculator.adjustedWeight;
        const renal_insufficency = $('[name="renal_insufficency"]:checked').val() ? $('[name="renal_insufficency"]:checked').val() : 0;
        this.protein.min = Number.parseFloat(renal_insufficency == 0 ? weight * 1.2 : weight * 0.8).toFixed(0);
        this.protein.max = Number.parseFloat(renal_insufficency == 0 ? weight * 1.5 : weight * 0.8).toFixed(0);

        this.$el.trigger('proteinChanged');
    }

    displayValues = () => {
        this.$gu.text(this.gu);
        this.displayEnergy();
        this.displayProtein();

    }

    displayProtein = () => {
        this.$proteinMin.text(this.protein.min);
        this.$proteinMax.text(this.protein.max);

        if (this.protein.min != 0 && (this.protein.min == this.protein.max)) {
            this.$separator.addClass('d-none');
            this.$proteinMax.addClass('d-none');
        } else {
            this.$separator.removeClass('d-none');
            this.$proteinMax.removeClass('d-none');
        }
    }

    displayEnergy = () => {
        this.$energy.text(this.energy);
    }
}

export default BMR;
